import React, { useState, useEffect } from 'react';
import eveImg2 from '../images/eveimg2.jpg';
import eveImg from '../images/eveimg.jpg';
import MandirBack from '../images/mandir-back.jpg';
import { GiPathDistance } from 'react-icons/gi';
import { FaLocationDot } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';


export default function Mandir() {

  const navigate = useNavigate();

  const [mandirList, setMandirList] = useState([]);

  const mndrList = [
    {
      name : "Dilwara Temple", 
      distance : 3,
      add : 'Jaipur, Rajasthan',
      am : 8,
      pm : 7,
      desc : "The list of the finest Jain temples in India is incomplete without a mention of Dilwara Temples. The holy site is a short distance from Mount Abu, Rajasthan’s only hill station. The temples are popular not just for its religious value but is renowned for beautiful and artistic marble carvings.",
      img : eveImg2
    },
    {
      name : "Dilwara Temple", 
      distance : 3,
      add : 'Jaipur, Rajasthan',
      am : 8,
      pm : 7,
      desc : "The list of the finest Jain temples in India is incomplete without a mention of Dilwara Temples. The holy site is a short distance from Mount Abu, Rajasthan’s only hill station. The temples are popular not just for its religious value but is renowned for beautiful and artistic marble carvings.",
      img : eveImg2
    },
    {
      name : "Dilwara Temple", 
      distance : 3,
      add : 'Jaipur, Rajasthan',
      am : 8,
      pm : 7,
      desc : "The list of the finest Jain temples in India is incomplete without a mention of Dilwara Temples. The holy site is a short distance from Mount Abu, Rajasthan’s only hill station. The temples are popular not just for its religious value but is renowned for beautiful and artistic marble carvings.",
      img : eveImg2
    },
  ]

  useEffect(()=>{
    setMandirList(mndrList);
  },[])

  return (
    <div>
      <div className='mt-5'>
        <div class="main-div">
          <img class="background-div" src={MandirBack} alt="Sea Image" />
           <div className='container'>
              <div className='row p-5'>
                  <div className='col-lg-12 col-md-8 col-sm-12 m-auto py-5'>
                    <div className='card bg-transparent border-0 text-center my-5'>
                      <div class="div-content py-4">
                        <p className='' style={{ fontFamily:'Poppins', fontSize:"3em", color:'#fff', fontWeight:400 }} >Finding your own place</p>
                      </div> 
                    </div>
                  </div>
              </div>
           </div>
        </div>
        <div className='container mt-5'>
          <div className='card rounded-0'>
            <div className='row d-flex align-items-center p-4'>
              <div className='col-lg-10 col-md-8 col-sm-12'>
                  <div className='row'>
                     <div className='col-lg-3 col-md-6 col-sm-12'>
                            <input id="search" className='sercc-inpt' type="search" placeholder="Country" autofocus required style={{width:"100%"}} />
                     </div>
                     <div className='col-lg-3 col-md-6 col-sm-12'>
                            <input id="search" className='sercc-inpt' type="search" placeholder="State" autofocus required style={{width:"100%"}} />
                     </div>
                     <div className='col-lg-3 col-md-6 col-sm-12'>
                            <input id="search" className='sercc-inpt' type="search" placeholder="City" autofocus required style={{width:"100%"}} />
                     </div>
                     <div className='col-lg-3 col-md-6 col-sm-12'>
                            <button className='btn-hover color-3 rounded-0 px-4 py-0' type="submit">Search</button> 
                     </div>
                  </div>
              </div>
              <div className='col-lg-2 col-md-6 col-sm-12'>
               <select class="form-select" aria-label="Default select example">
                  <option selected>Mandir type</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
        <p className='text-center mt-5' style={{ fontFamily:'Poppins', fontSize:"2em", color:'#1f5156', fontWeight:500 }}>Mandirs</p>
          <div className='row'>
              {
                mandirList.map((item, index)=>{
                  return(
                    <div key={index} className='col-lg-4 col-md-6 col-sm-12'>
                       <div onClick={()=> navigate('/MandirDetail')} className='card rounded-2 border-0 mandir-card mb-3' style={{ width:'100%', cursor:'pointer' }} >
                         <div class="minder-card">
                          <img src={eveImg2} className="card-img-top mandir-background-div"  alt="..." />
                             <div class="mandir-div-content pb-5 p-2">
                               <div className='' style={{ fontFamily:'Poppins', fontSize:"14px", color:'#fff', fontWeight:500 }} >Dilwara Temple</div>
                             </div>
                             <div className='px-2 d-flex justify-content-between pt-5'>
                                 <div className='d-flex align-items-center justify-content-center'> 
                                    <div class="mandir-div-content">
                                    <GiPathDistance className='me-1 pb-1' style={{color:'#fff', fontSize:'16px'}} />
                                    </div>
                                    <div class="mandir-div-content">
                                      <div className='' style={{ fontFamily:'Poppins', fontSize:".7em", color:'#fff', fontWeight:400 }} >{item.distance} km from city</div>
                                    </div>
                                 </div>
                                 <div className='d-flex align-items-center'>
                                    <div class="mandir-div-content">
                                    <FaLocationDot className='me-1 pb-1' style={{color:'#fff', fontSize:'14px'}} />
                                    </div>
                                    <div class="mandir-div-content">
                                      <div className='' style={{ fontFamily:'Poppins', fontSize:".7em", color:'#fff', fontWeight:400 }} >{item.add}</div>
                                    </div>
                                 </div>
                             </div>
                          </div>
                            <div className='p-2'>
                              <div className="pt-2" style={{ fontFamily:'Poppins', fontSize:"12px", color:'#1f5156', fontWeight:500, lineHeight:1.6, letterSpacing:1.5}}>Timing : ({item.am} AM to {item.pm} PM)</div>
                              <div className="pb-2" style={{ fontFamily:'Poppins', fontSize:"12px", color:'#00000099', fontWeight:400, lineHeight:1.6}}>{item.desc}</div>
                            </div>
                          </div>
                     </div>
                  )
                })
              }
          </div>
        </div>
      </div>
    </div>
  )
}
